import React from 'react';
import '../styles/campaignCard.css';

const CampaignCard = ({ campaign, onClick }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(campaign);
        }
    };

    return (
        <div className="campaign-card" onClick={handleClick}>
            <div className="campaign-image-container">
                {campaign.imageUrl ? (
                    <img 
                        src={campaign.imageUrl} 
                        alt={campaign.caption?.title || 'Campaign'} 
                        className="campaign-image"
                        loading="lazy"
                    />
                ) : (
                    <div className="campaign-placeholder">
                        <span>📢</span>
                    </div>
                )}
                <div className="campaign-badge">
                    <span className="badge-icon">✨</span>
                    <span className="badge-text">Sponsorisé</span>
                </div>
            </div>
            <div className="campaign-content">
                <h3 className="campaign-title">
                    {campaign.caption?.title || campaign.title || 'Promotion'}
                </h3>
                <p className="campaign-client">
                    {campaign.caption?.text || `Sponsorisé par ${campaign.client_name || 'Wennze'}`}
                </p>
            </div>
        </div>
    );
};

export default CampaignCard;
